import React from 'react';
import { CircularProgress, Grid, Box } from '@mui/material';
import { Section, InfoFrame } from '../../../components';
import Base from '../../../templates/Base';

function MessageDisplay(props) {
  const { message, isLoading } = props;
  let title = 'Carregando...';
  let texts = null;
  if (!isLoading) {
    texts = message.get('mensagens');
    title = message.get('titulo');
  }

  return (
    <Base title="Cadastro" subtitle="Confirmação de Cadastro">
      <Section title={title} titleColor="primary" headerGutter>
        <Grid size={12}>
          {texts ? (
            texts.map((m) => <InfoFrame key={m} text={m} />).toArray()
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          )}
        </Grid>
      </Section>
    </Base>
  );
}

export default MessageDisplay;
